import { Fragment } from "react";
import { ListViewItem } from "@/react/components/Events/NewEventsSpace/ListViewItem";
import { Typography } from "@circle-react-uikit/Typography";

export const EventsListByMonth = ({
  eventsByMonth = new Map(),
  nextEvent,
  onEventDestroy,
  onEventChange,
  isThumbnailView,
}: any) => (
  <>
    {Array.from(eventsByMonth.keys()).map((month: any) => {
      const [firstMonth] = eventsByMonth.keys();
      let eventList = eventsByMonth.get(month);
      if (month === firstMonth && nextEvent) {
        eventList = eventList.filter((event: any) => event.id !== nextEvent.id);
      }
      if (!eventList.length) return null;
      return (
        <Fragment key={month}>
          <div className="mx-6 mt-3 md:mx-0">
            <Typography.TitleSm weight="bold">{month}</Typography.TitleSm>
          </div>
          <div className="bg-primary border-primary mb-9 mt-6 border-y sm:rounded-lg sm:border">
            {eventList.map((event: any) => (
              <ListViewItem
                key={event.id}
                event={event}
                onDestroy={() => onEventDestroy(event.id)}
                onRsvp={() => onEventChange(event)}
                isThumbnailView={isThumbnailView}
              />
            ))}
          </div>
        </Fragment>
      );
    })}
  </>
);
